'use client';
import React from 'react';

export default function IntroSection() {
  return (
    <section
      className="py-12 px-4"
      style={{ backgroundColor: 'rgb(3, 8, 16)' }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <p
          className="leading-relaxed"
          style={{ color: 'rgb(136, 147, 152)', fontSize: 'clamp(16px, 2vw, 22px)' }}
        >
          Serious Swag is not a print shop &mdash; it&apos;s a{' '}
          <span
            className="font-bold"
            style={{ color: '#00b4ff' }}
          >
            premium merchandise ecosystem
          </span>{' '}
          engineered to give your business an unfair advantage. Every product below is purpose-built,
          tactilely superior, and relentlessly focused on one thing:{' '}
          <span className="font-bold text-white">your brand dominance</span>.
        </p>
      </div>
    </section>
  );
}
